import { create } from 'zustand';
import { GroupMemberLinkPreviewData } from '../dto/EntityRepository';

interface GroupMemberLinkState {
  overwriteData: GroupMemberLinkPreviewData | null;
  setOverwriteData: (overwriteData: GroupMemberLinkPreviewData) => void;
  clearOverwriteData: () => void;
}

export const useGroupMemberLinkStore = create<GroupMemberLinkState>((set) => ({
  overwriteData: null,
  setOverwriteData: (overwriteData) => set({ overwriteData }),
  clearOverwriteData: () => set({ overwriteData: null }),
}));
